import React, { useCallback } from 'react';
import classnames from 'classnames';
import { MoreOutlined } from '@ant-design/icons';
import { Dropdown, Menu } from 'antd';

import BtnLink, { BtnLinkProps } from '../btn-link';
import { EditModalForm, useEditModal, DeleteContent } from './components/edit-modal';

import style from './index.less';

type ValueType = string | number;

type DataItem = {
  label: number;
  value: ValueType;
  disabled?: boolean;
};

type Options = {
  item: DataItem;
};

type OperateDorpdownProps = {
  item: DataItem;
  onEdit?: (value: ValueType, extra: Options) => void;
  onDelete?: (value: ValueType, extra: Options) => void;
};

const OperateDropdown = (props: OperateDorpdownProps): JSX.Element => {
  const { onEdit, onDelete, item } = props;
  const { value } = item;

  const handleEdit = useCallback(
    (e: Event, value: ValueType) => {
      e.stopPropagation();
      if (onEdit) {
        onEdit(value, {
          item
        });
      }
    },
    [onEdit, item]
  );

  const handleDelete = useCallback(
    (e: Event, value: ValueType) => {
      e.stopPropagation();
      if (onDelete) {
        onDelete(value, {
          item
        });
      }
    },
    [item, onDelete]
  );

  const getContent = useCallback(() => {
    const items: any[] = [];
    if (onEdit) {
      items.push({
        key: 'edit',
        label: '编辑',
        onClick: ({ domEvent }) => handleEdit(domEvent, value)
      });
    }
    if (onDelete) {
      items.push({
        key: 'delete',
        label: '删除',
        onClick: ({ domEvent }) => handleDelete(domEvent, value)
      });
    }
    return <Menu items={items} />;
  }, [handleEdit, handleDelete, value]);
  return (
    <Dropdown dropdownRender={getContent} trigger={['click']} placement="bottomRight">
      <MoreOutlined style={{ cursor: 'pointer' }} onClick={e => e.stopPropagation()} />
    </Dropdown>
  );
};

type EditListProps = {
  value?: ValueType;
  data: Array<DataItem>;
  onClick: (value: ValueType) => void;
  title?: string;
  onClickTitle?: () => void;
  className?: string;
  onEdit?: (value: ValueType, extra: Options) => void;
  onDelete?: (value: ValueType, extra: Options) => void;
  disableOperate?: boolean;
  titleProps?: BtnLinkProps;
};

const EditList = (props: EditListProps): JSX.Element => {
  const {
    data,
    onClick,
    onClickTitle,
    title,
    className,
    value: selectValue,
    onEdit,
    onDelete,
    disableOperate,
    titleProps
  } = props;

  return (
    <div className={classnames(style['edit-list'], className)}>
      {title ? (
        <BtnLink
          {...titleProps}
          onClick={() => {
            if (onClickTitle) {
              onClickTitle();
            }
          }}>
          {title}
        </BtnLink>
      ) : null}

      <div>
        {data.map(val => {
          const { value, label, disabled } = val;
          return (
            <div
              className={`${style.item} ${value === selectValue ? 'active' : ''}`}
              key={value}
              onClick={() => onClick(value)}>
              <div className={style.name} title={`${String(label ?? '')}`}>
                {String(label ?? '')}
              </div>
              {!disabled && !disableOperate ? <OperateDropdown item={val} onEdit={onEdit} onDelete={onDelete} /> : null}
            </div>
          );
        })}
      </div>
    </div>
  );
};

EditList.EditModalForm = EditModalForm;
EditList.DeleteContent = DeleteContent;
EditList.useEditModal = useEditModal;

export default EditList;
